export default __webpack_public_path__ + "df2956acf3811eebd809194c136bbecc.woff";